module.exports = "<sub-menu [menu]=\"menu\" defaultNavWrapperWidth=\"50\"></sub-menu>\n<router-outlet></router-outlet>\n"